import Hud from 'app/ui/hud/Hud';
import { GetDefaultButtonCostume } from '../ui/hud/HudConstants';
import LocationCharacters from './LocationCharacters';

export default class LocationDisplay extends Phaser.Group {
  constructor(game, locationid) {
    super(game);

    this.fixedToCamera = true;

    this.locationid = locationid;

    // dispatch position change
    this.onPositionChanged = new Phaser.Signal();
    this.onActivitySelected = new Phaser.Signal();

    // currently the bg image is 1 big image
    // you may need to chopthis up into smaller ones and stitch back together due to mobile limitations
    this.background = this.game.make.image(0, 0, 'location_bg');
    this.add(this.background);

    this.characters = new LocationCharacters(this.game);
    this.characters.x = 1060;
    this.characters.y = 263;
    this.add(this.characters);

    this.buttons = LocationDisplay.BUTTONS.map((btnData) => {
      // I've seperated out the costume to allow for
      // checks to update the default up frame to a
      // lovely green icon if the user has already
      // done said activity on the location
      let btnCostume = { ...GetDefaultButtonCostume(btnData.costume) };

      if (btnData.id != 'leave') {
        btnCostume.up = this.visitedIcon(btnData.id) ? btnData.visited : btnData.unvisited;
      }

      const btn = Hud.CreateHudButton({ ...btnData, ...btnCostume }, this.game);
      btn.x = btnData.x;
      btn.y = btnData.y;
      btn.onInputDown.add(this.handleLocationButton, this);
      this.add(btn);

      if (btn.id === 'leave') {
        btn.visible = this.game.gameController.player.getCanLeaveLocation(this.locationid);
      }
      if (btn.id === 'chasegame') {
        btn.visible = this.game.gameController.player.getCanPlayChaseGame(this.locationid);
      }

      return btn;
    });
    // set start position to center background
    this.cameraOffset.x = -(this.background.width * 0.5 - this.game.width * 0.5);
  }

  checkActiveButtons() {
    if (__WATCH__) {
      // allow all buttons during dev :)
      // return;
    }

    let reveal = [];
    this.buttons.forEach((btn) => {
      if (btn.id === 'leave') {
        const leaveRequirementsMet = this.game.gameController.player.getLeaveLocationRequirementsMet(
          this.locationid
        );
        const canLeave = this.game.gameController.player.getCanLeaveLocation(this.locationid);

        if (leaveRequirementsMet && !canLeave) {
          this.game.gameController.player.setCanLeaveLocation(this.locationid);
          reveal.push(btn);
        }
      }

      if (btn.id === 'chasegame') {
        const chaseRequirementsMet = this.game.gameController.player.getChaseGameRequirementsMet(
          this.locationid
        );
        const chaseGameUnlocked = this.game.gameController.player.getCanPlayChaseGame(
          this.locationid
        );

        if (chaseRequirementsMet && chaseGameUnlocked == false) {
          this.game.gameController.player.setCanPlayChaseGame(this.locationid);
          reveal.push(btn);
        }
      }

      // custom sound for selfie
      if (btn.id == 'selfie') {
        btn.setSfx({ spriteID: 'general_audio', audioID: 'camera' });
      }
    });

    return reveal;
  }

  handleLocationButton(btn) {
    console.log(this.visitedIcon(btn.id));
    if (!this.visitedIcon(btn.id)) {
      this.updateIcon(btn);
    }
    this.onActivitySelected.dispatch(btn.id, this.locationid);
  }

  /*
  ==================================================================================
    PAN ALONG X AXIS
  ==================================================================================
  */

  panLeft(distance = 500) {
    const tx = Math.max(this.game.width - this.background.width, this.cameraOffset.x - distance);
    this.tweenToPosistion(tx, distance);
    this.panTween.onComplete.add(this.handleTweenComplete, this);
  }

  panRight(distance = 500) {
    const tx = Math.min(0, this.cameraOffset.x + distance);
    this.tweenToPosistion(tx, distance);
  }

  /*
  ==================================================================================
    TWEEN TO X POSITION
  ==================================================================================
  */

  tweenToPosistion(pos, duration = 500) {
    this.clearTween();
    this.panTween = this.game.add
      .tween(this.cameraOffset)
      .to({ x: pos }, duration, Phaser.Easing.Quartic.Out, true);
    this.panTween.onComplete.add(this.handleTweenComplete, this);
    return this.panTween;
  }

  handleTweenComplete() {
    this.panTween.onComplete.remove(this.handleTweenComplete, this);
    this.onPositionChanged.dispatch();
  }

  clearTween() {
    if (this.panTween) {
      this.panTween.stop();
      this.panTween.onComplete.removeAll();
      this.game.tweens.remove(this.panTween);
      this.panTween = null;
    }
  }

  /*
  ==================================================================================
    Update the icon visited state
  ==================================================================================
  */

  updateIcon(btn) {
    let button = LocationDisplay.BUTTONS.find((btnData) => {
      return btnData.id == btn.id;
    });
    // This seems very hacky but couldn't seem to find
    // a different way to do it???
    btn.setFrames(btn._onOverFrame, button.visited, btn._onDownFrame, button.visited);
  }

  visitedIcon(id) {
    switch (id) {
      case 'foodgame':
        return this.game.gameController.player.getFoodGamePlayed(this.locationid);
        break;
      case 'leave':
        return this.game.gameController.player.getCanLeaveLocation(this.locationid);
        break;
      case 'selfie':
        return this.game.gameController.player.getSelfieSeen(this.locationid);
        break;
      case 'chasegame':
        return this.game.gameController.player.getChaseGamePlayed(this.locationid);
        break;
      case 'video':
        return this.game.gameController.player.getVideoSeen(this.locationid);
        break;
      case 'poll':
        return this.game.gameController.player.getPollSeen(this.locationid);
        break;
      case 'souvenir':
        return this.game.gameController.player.getSouvenirSeen(this.locationid);
        break;
      default:
    }
  }

  /*
  ==================================================================================
    CHECK IF CAN MOVE
  ==================================================================================
  */

  canMoveLeft() {
    return this.cameraOffset.x > this.game.width - this.background.width;
  }
  canMoveRight() {
    return this.cameraOffset.x < 0;
  }

  /*
  ==================================================================================
    CLEAN UP
  ==================================================================================
  */

  destroy() {
    this.clearTween();
    this.buttons.forEach((btn) => {
      btn.destroy(true);
    });
    this.buttons = null;
    this.onPositionChanged.removeAll();
    this.onPositionChanged = null;
    this.background.destroy(true);
    this.background = null;
    super.destroy(true);
  }
}

// Organised into running order on location state
LocationDisplay.FOOD_GAME = 'foodgame';
LocationDisplay.LEAVE = 'leave';
LocationDisplay.SELFIE = 'selfie';
LocationDisplay.CHASE_GAME = 'chasegame';
LocationDisplay.VIDEO = 'video';
LocationDisplay.POLL = 'poll';
LocationDisplay.SOUVENIR = 'souvenir';

LocationDisplay.BUTTONS = [
  {
    id: 'foodgame',
    x: 300,
    y: 200,
    costume: 'food_game_button',
    unvisited: 'btn_foodgame_pink',
    visited: 'btn_complete_food',
  },
  {
    id: 'leave',
    x: 700,
    y: 450,
    costume: 'world_button',
  },
  {
    id: 'selfie',
    x: 1250,
    y: 200,
    costume: 'phone_button',
    unvisited: 'btn_selfie_pink',
    visited: 'btn_complete_selfie',
  },
  {
    id: 'chasegame',
    x: 1650,
    y: 450,
    costume: 'mini_game_button',
    unvisited: 'btn_chasegame_pink',
    visited: 'btn_complete_chase',
  },
  {
    id: 'video',
    x: 1845,
    y: 245,
    costume: 'play_video_button',
    unvisited: 'btn_video_pink',
    visited: 'btn_complete_video',
  },
  {
    id: 'poll',
    x: 2200,
    y: 450,
    costume: 'poll_button',
    unvisited: 'btn_poll_pink',
    visited: 'btn_complete_poll',
  },
  {
    id: 'souvenir',
    x: 2500,
    y: 200,
    costume: 'present_button',
    unvisited: 'btn_souvenir_pink',
    visited: 'btn_complete_souvenir',
  },
];



// WEBPACK FOOTER //
// ./js/app/location/LocationDisplay.js